import { jsx as _jsx } from "react/jsx-runtime";
export const CheckIcon = ({ color }) => {
    return (_jsx("svg", { width: "24", height: "17", viewBox: "0 0 24 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.19973 16.9L0.799805 8.4999L3.5998 5.69992L9.19973 11.3001L20.3998 0.0999756L23.1998 2.89999L9.19973 16.9Z", fill: color }) }));
};
